import getLanguageFromStorage from '../helpers/getLanguageFromStorage';
export const PaymentTypeToTranslation = {
    CREDIT_CARD: (lang) => lang === 'es' ? 'Tarjetas que termina en' : 'Card ending in',
    PINLESS_DEBIT_CARD: (lang) => lang === 'es' ? 'Tarjetas que termina en' : 'Card ending in',
    CHECKING: (lang) => lang === 'es' ? 'Cheque' : 'Checking',
    SAVINGS: (lang) => (lang === 'es' ? 'Ahorro' : 'Savings')
};
function normalizePaymentMethodType(paymentMethod) {
    const { paymentMedium, type } = paymentMethod;
    if (type === 'WALLET') {
        throw new Error(`${type} is an unsupported payment type`);
    }
    if (paymentMedium && paymentMedium !== 'E_CHECK') {
        return paymentMedium;
    }
    return type;
}
const formatDisplayAccount = (paymentMethod) => {
    const lang = getLanguageFromStorage();
    const paymentType = normalizePaymentMethodType(paymentMethod);
    const translationFunc = PaymentTypeToTranslation[paymentType];
    const translatedPaymentType = translationFunc && translationFunc(lang);
    const isBankAccount = ['CHECKING', 'SAVINGS'].includes(paymentType);
    if (!translationFunc) {
        throw new Error(`no translation for payment type: ${paymentMethod.type}`);
    }
    if (isBankAccount) {
        const { bankAccountNumberLast4, name, nickname } = paymentMethod;
        const accountNumber = bankAccountNumberLast4
            ? ` (...${bankAccountNumberLast4})`
            : '';
        return [nickname || name, `${translatedPaymentType}${accountNumber}`]
            .filter(Boolean)
            .join(', ');
    }
    const { cardNumberLast4 } = paymentMethod;
    return `${translatedPaymentType} (...${cardNumberLast4})`;
};
export default formatDisplayAccount;
